import { render } from "./NewURLReader.vue?vue&type=template&id=1fbe1074"
import script from "./NewURLReader.vue?vue&type=script&lang=js"
export * from "./NewURLReader.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__